import { USER_TYPE } from '../actions/types';

export default function(state = null, action) {
  switch (action.type) {
    case USER_TYPE:
      return action.payload;
    default:
      return state;
  }
}